import { connect } from "react-redux";
import CaseView from "./View";
import { bindActionCreators } from "redux";
import {caseByIdRequest, caseStatusUpdateRequest, loanAccountRequest, loanTranchesRequest} from "../../../../../service/Dealer/action";


const mapStateToProps = (state) => ({
    caseByIdResponse : state.Dealer.caseByIdResponse,
    caseStatusUpdateResponse : state.Dealer.caseStatusUpdateResponse,
    loanAccountResponse: state.Dealer.loanAccountResponse,
    loanTranchesResponse: state.Dealer.loanTranchesResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        caseByIdRequest,
        caseStatusUpdateRequest,
        loanAccountRequest,
        loanTranchesRequest,
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CaseView);